import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Checkbox,
    DataTable,
    EmptyState,
    Icon,
    Popover,
    Spinner,
    Stack,
    TextField,
    TextStyle,
    Filters,
    ActionList,
    Thumbnail,
    TextContainer,
    ChoiceList,
    CalloutCard,
    ProgressBar,
    DisplayText,
} from "@shopify/polaris"
import { DeleteMinor, EditMinor, SearchMinor, SendMajor } from "@shopify/polaris-icons"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import axios from "../../funcs/axios"
import formatDateTime from "../../utils/formatDateTime"

function mapStateToProps(state) {
    return {
        app_settings: state.app_settings,
        app_render: state.app_render,
        app_edited: state.app_edited,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
class Notifications extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listCheckbox: [],
            checkAll: false,
            data_notifications: JSON.parse(JSON.stringify(props.data_notifications)),
            loading: props.loading,
            textSearch: "",
            active: false,
            sort: [],
            count_mail: props.count_mail,
        }
    }

    componentDidMount() {
        this.setState({ listCheckBox: [] })
    }

    static getDerivedStateFromProps(props, state) {
        const { data_notifications, loading, count_mail } = props
        if (state.data_notifications !== props.data_notifications) {
            return {
                data_notifications: JSON.parse(JSON.stringify(data_notifications)),
                loading,
                count_mail:count_mail,
            }
        }
        // Return null to indicate no change to state.
        return null
    }

    handleCheckAll = () => {
        const { data_notifications, checkAll } = this.state
        let newListCheckbox = []
        if (!checkAll) {
            data_notifications.map((item, index) => {
                let data = {
                    id: item.create_at,
                }
                return newListCheckbox.push(data)
            })
        }
        this.setState({ listCheckbox: newListCheckbox })
        this.setState({ checkAll: !checkAll })
    }

    checkItemExistsInArray = (array, id) => {
        if (!array.length) return false
        for (let i = 0; i < array.length; i++) {
            if (array[i].id == id) {
                return true
            }
        }
        return false
    }

    handleChangeProductsSelected = (id) => {
        const { listCheckbox, data_notifications } = this.state
        let newListCheckbox = [...listCheckbox]
        let data = {
            id,
        }
        let flag = this.checkItemExistsInArray(newListCheckbox, id)
        if (flag) {
            newListCheckbox = newListCheckbox.filter((item) => item.id != id)
        } else {
            newListCheckbox.push(data)
        }
        if (newListCheckbox.length === data_notifications.length) this.setState({ checkAll: true })
        else this.setState({ checkAll: false })
        this.setState({ listCheckbox: newListCheckbox })
    }

    togglePopoverActive = (index) => {
        this.setState({ [index]: !this.state[index] })
    }

    activator = (item, index) => {
        return (
            <Button
                onClick={() => this.togglePopoverActive(index)}
                disclosure
                plain
                monochrome
                removeUnderline
                textAlign="left"
            >
                <TextContainer spacing="tight">
                    <p>
                        <TextStyle>{item.title}</TextStyle>
                    </p>
                    <p>
                        <TextStyle variation="subdued">
                            {formatDateTime(item.create_at, "Ago")}
                        </TextStyle>
                    </p>
                </TextContainer>
            </Button>
        )
    }

    sendMail = (item, param) => {
        let { data_notifications } = this.state
        let clone = [...data_notifications]
        let idx = clone.findIndex((e) => e.create_at == param)
        clone[idx].status = 2
        this.props.handleSetWaiting(clone)
        let array = []
        array.push(item)
        this.setState({ listCheckBox: [] })
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/send-mail-notifications`, array)
            .then((res) => {
                console.log(`res`, res)
                if (res.data.status == "success") {
                    this.props.handleReload()
                    setTimeout(() => {
                        this.props.actions.AppNotify({
                            content: res.data.msg,
                            show: true,
                            error: false,
                        })
                    }, 1000)
                } else {
                    this.props.actions.AppNotify({
                        content: res.data.msg,
                        show: true,
                        error: true,
                    })
                }
            })
    }

    deleteNotifications = (item, param) => {
        let { data_notifications } = this.state
        let clone = [...data_notifications]
        let idx = clone.findIndex((e) => e.create_at == param)
        clone[idx].status = 2
        this.props.handleSetWaiting(clone)
        let array = []
        array.push(item)
        this.setState({ listCheckBox: [] })
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/delete-notifications`, array).then((res) => {
            console.log(`res`, res)
            if (res.data.status == "success") {
                this.props.handleReload()
                setTimeout(() => {
                    this.props.actions.AppNotify({
                        content: res.data.msg,
                        show: true,
                        error: false,
                    })
                }, 1000)
            } else {
                this.props.actions.AppNotify({
                    content: res.data.msg,
                    show: true,
                    error: true,
                })
            }
        })
    }

    deleteBulkNotifications = () => {
        const { listCheckbox, data_notifications } = this.state
        let array = []
        listCheckbox.map((item) => {
            let clone = [...data_notifications]
            let idx = clone.findIndex((e) => e.create_at == item.id)
            clone[idx].status = 2
            this.props.handleSetWaiting(clone)
            if (data_notifications[idx]) array.push(data_notifications[idx])
        })
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/delete-notifications`, array).then((res) => {
            if (res.data.status == "success") {
                this.props.handleReload()
                setTimeout(() => {
                    this.props.actions.AppNotify({
                        content: res.data.msg,
                        show: true,
                        error: false,
                    })
                }, 1000)
            } else {
                this.props.actions.AppNotify({
                    content: res.data.msg,
                    show: true,
                    error: true,
                })
            }
        })
    }

    sendBulkMail = () => {
        const { listCheckbox, data_notifications } = this.state
        let array = []
        listCheckbox.map((item) => {
            let clone = [...data_notifications]
            let idx = clone.findIndex((e) => e.create_at == item.id)
            clone[idx].status = 2
            this.props.handleSetWaiting(clone)
            if (data_notifications[idx]) array.push(data_notifications[idx])
        })
        this.setState({ listCheckBox: [] })
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/send-mail-notifications`, array)
            .then((res) => {
                if (res.data.status == "success") {
                    this.props.handleReload()
                    setTimeout(() => {
                        this.props.actions.AppNotify({
                            content: res.data.msg,
                            show: true,
                            error: false,
                        })
                    }, 1000)
                } else {
                    this.props.actions.AppNotify({
                        content: res.data.msg,
                        show: true,
                        error: true,
                    })
                }
            })
    }

    toggleActive = () => {
        this.setState({ active: !this.state.active })
    }

    isEmpty(value) {
        if (Array.isArray(value)) {
            return value.length === 0
        } else {
            return value === "" || value == null
        }
    }

    handleSort = (type) => (a, b) => {
        switch (type.toString()) {
            case "Date (oldest first)":
                return a.create_at - b.create_at
            case "Date (newest first)":
                return b.create_at - a.create_at
            case "Status (Yes - No)":
                return a.status - b.status
            case "Status (No - Yes)":
                return b.status - a.status
            default:
                return b.create_at - a.create_at
        }
    }

    handleSearch = (keyword) => (e) => e.title.toLowerCase().includes(keyword.toLowerCase())

    render() {
        const { checkAll, listCheckbox, active, loading, textSearch, sort, count_mail } = this.state
        console.log('count_mail', count_mail)
        let { data_notifications } = this.state
        const activator = (
            <Button onClick={() => this.toggleActive()} disclosure>
                Actions
            </Button>
        )

        const items = [
            {
                content: "Delete",
                onAction: () => this.deleteBulkNotifications(),
            },
        ]
        if (this.props.sendBulk) {
            items.push({
                content: "Send notifications",
                onAction: () => this.sendBulkMail(),
            })
        }

        let rows = [],
            heading = [
                <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />,
                "Image",
                "Product",
                "Contact",
                "Send type",
                "Status",
                // "Message",
                "Action",
            ]
        data_notifications = data_notifications.filter(this.handleSearch(textSearch))
        data_notifications = data_notifications.sort(this.handleSort(sort))
        for (let i = 0; i < data_notifications.length; i++) {
            let array = []
            array.push(
                <Checkbox
                    onChange={() =>
                        this.handleChangeProductsSelected(data_notifications[i].create_at)
                    }
                    checked={this.checkItemExistsInArray(
                        listCheckbox,
                        data_notifications[i].create_at,
                    )}
                />,
            )
            array.push(
                <div className="productInfo">
                    <Thumbnail
                        source={"https://" + data_notifications[i].image}
                        size="medium"
                        alt="Black choker necklace"
                    />
                </div>,
            )
            array.push(
                <Popover
                    active={this.state[i]}
                    activator={this.activator(data_notifications[i], i)}
                    onClose={() => this.togglePopoverActive(i)}
                >
                    <Popover.Pane fixed>
                        <Popover.Section>
                            <p>Product</p>
                        </Popover.Section>
                    </Popover.Pane>
                    <Popover.Pane>
                        <ActionList
                            items={[
                                {
                                    content: (
                                        <span style={{ fontWeight: "bold" }}>
                                            {data_notifications[i].title}
                                        </span>
                                    ),
                                },
                                { content: `Variant: ${data_notifications[i].titleVariant}` },
                                { content: `Variant ID: ${data_notifications[i].variantId}` },
                            ]}
                        />
                    </Popover.Pane>
                </Popover>,
            )
            array.push(
                <h3>
                    <TextStyle>{data_notifications[i].email}</TextStyle>
                </h3>,
            )
            array.push(
                <h3>
                    <TextStyle>Email</TextStyle>
                </h3>,
            )
            array.push(
                <div>
                    <Badge
                        progress="complete"
                        status={
                            data_notifications[i].status == 1
                                ? "default"
                                : data_notifications[i].status == 2
                                ? "attention"
                                : "warning"
                        }
                    >
                        {data_notifications[i].status == 1
                            ? "Sent"
                            : data_notifications[i].status == 2
                            ? "Waiting"
                            : "Unsent"}
                    </Badge>
                </div>,
            )
            array.push(
                <ButtonGroup segmented>
                    <Button
                        icon={<Icon source={SendMajor} />}
                        size="slim"
                        disabled={data_notifications[i].status == 1}
                        onClick={() =>
                            this.sendMail(data_notifications[i], data_notifications[i].create_at)
                        }
                    ></Button>
                    <Button
                        onClick={() =>
                            this.deleteNotifications(
                                data_notifications[i],
                                data_notifications[i].create_at,
                            )
                        }
                        destructive
                        icon={<Icon source={DeleteMinor} />}
                        size="slim"
                    ></Button>
                </ButtonGroup>,
            )
            rows.push(array)
        }
        console.log("listCheckbox", listCheckbox)
        if (listCheckbox.length) {
            heading = []
            heading.push(
                <ButtonGroup segmented>
                    <Button
                        icon={
                            <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />
                        }
                        onClick={() => this.handleCheckAll()}
                    >
                        {listCheckbox.length} selected
                    </Button>
                    <Popover
                        active={active}
                        activator={activator}
                        onClose={() => this.toggleActive()}
                    >
                        <ActionList items={items} />
                    </Popover>
                </ButtonGroup>,
            )

            if (document.getElementsByTagName("th")[0]) {
                let th = document.getElementsByTagName("th")[0]
                th.setAttribute("colspan", 7)
            }
        } else {
            if (document.getElementsByTagName("th")[0]) {
                let th = document.getElementsByTagName("th")[0]
                th.removeAttribute("colspan")
            }
        }

        const appliedFilters = []
        if (!this.isEmpty(sort)) {
            const key = "Sort"
            appliedFilters.push({
                key,
                label: sort,
                onRemove: () => this.setState({ sort: [] }),
            })
        }

        const filters = [
            {
                key: "Sort",
                label: "Sort",
                filter: (
                    <ChoiceList
                        title="Availability"
                        titleHidden
                        choices={[
                            { label: "Date (oldest first)", value: "Date (oldest first)" },
                            { label: "Date (newest first)", value: "Date (newest first)" },
                            { label: "Status (Yes - No)", value: "Status (Yes - No)" },
                            { label: "Status (No - Yes)", value: "Status (No - Yes)" },
                        ]}
                        selected={sort || []}
                        onChange={(val) => this.setState({ sort: val })}
                    />
                ),
                shortcut: true,
            },
        ]
        return (
            <>
                {!loading ? (
                    <>
                        <div style={{ marginBottom: "20px" }}>
                            <Card sectioned title="Your plan usage">
                                <Stack vertical>
                                    <p>
                                        View all notifications and send to your customers that
                                        created before
                                    </p>

                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100%" }}>
                                            <p style={{ fontSize: "13px" }}>
                                                <TextStyle variation="subdued">
                                                    {`${count_mail}/100 notifications`}
                                                </TextStyle>
                                            </p>
                                            <ProgressBar progress={count_mail} size="small" />
                                        </div>

                                        <img
                                            style={{ marginLeft: "20px" }}
                                            width={80}
                                            src={
                                                "https://cdn.shopify.com/s/files/1/0516/9132/3550/t/17/assets/sendmail.png?v=1621225510"
                                            }
                                        />
                                    </div>

                                    <Button primary>Upgrade</Button>
                                </Stack>
                            </Card>
                        </div>
                        <Card>
                            <Card.Section>
                                <Filters
                                    queryPlaceholder="Filter notifications by product"
                                    queryValue={textSearch}
                                    filters={filters}
                                    appliedFilters={appliedFilters}
                                    onQueryChange={(val) => this.setState({ textSearch: val })}
                                    onQueryClear={() => this.setState({ textSearch: "" })}
                                    // onClearAll={handleFiltersClearAll}
                                />
                            </Card.Section>
                            {data_notifications.length ? (
                                <Card.Section>
                                    <DataTable
                                        hideScrollIndicator={true}
                                        columnContentTypes={[
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                        ]}
                                        headings={heading}
                                        rows={rows}
                                    ></DataTable>
                                </Card.Section>
                            ) : (
                                <Card.Section>
                                    <Card.Section>
                                        <EmptyState
                                            heading="No notifications"
                                            image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                                        >
                                            <p>
                                                We couldn't find any result. Please add to
                                                notifications
                                            </p>
                                        </EmptyState>
                                    </Card.Section>
                                </Card.Section>
                            )}
                        </Card>
                    </>
                ) : (
                    <Stack distribution="center">
                        <div style={{ marginTop: "20px", display: "flex" }}>
                            <Spinner
                                accessibilityLabel="Loading more customers"
                                size="large"
                                color="teal"
                            />
                        </div>
                    </Stack>
                )}
            </>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
